import { ApiError, NetworkError } from '../../lib/api';
import { inventoryMessages } from './api';

export interface Problem {
  fields: Record<string, string>;
  form: string | null;
}

export const noProblem: Problem = { fields: {}, form: null };

/** Maps an inventory API failure onto form-level and field-level messages. */
export function toProblem(err: unknown): Problem {
  if (err instanceof ApiError) {
    if (err.status === 422) return { fields: inventoryMessages(err.fields), form: null };
    if (err.status === 409 && err.code === 'site_not_empty')
      return { fields: {}, form: 'Esta conta ainda tem dispositivos. Mova-os ou exclua-os antes.' };
    if (err.status === 409 && err.code === 'client_has_users')
      return {
        fields: {},
        form: 'Este cliente ainda tem usuários. Mude-os de cliente ou exclua-os antes.',
      };
    if (err.status === 409 && err.code === 'client_not_empty')
      return {
        fields: {},
        form: 'Este cliente ainda tem contas. Mova-as para outro cliente ou exclua-as antes.',
      };
    if (err.status === 409 && err.code === 'recorder_channel')
      return {
        fields: {},
        form: 'Canais são gerenciados pelo gravador: desative o canal ou reduza a quantidade de canais no gravador.',
      };
    if (err.status === 409 && err.code === 'no_media_node')
      return {
        fields: {},
        form: 'Nenhuma máquina de vídeo pode receber equipamentos agora: todas estão fora do ar, pausadas ou com 70% da capacidade ocupada. Peça ao administrador da plataforma para liberar espaço ou cadastrar uma máquina de vídeo.',
      };
    if (err.status === 409 && err.code === 'not_recorder')
      return { fields: {}, form: 'Este dispositivo não é mais um gravador com canais.' };
    if (err.status === 403) return { fields: {}, form: 'Você não tem permissão para esta ação.' };
    if (err.status === 404) return { fields: {}, form: 'Este registro não existe mais.' };
  }
  if (err instanceof NetworkError)
    return { fields: {}, form: 'Não foi possível contatar o servidor. Tente novamente.' };
  return { fields: {}, form: 'Ocorreu um erro inesperado. Tente novamente.' };
}
